import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { sortArray } from '@nu-art/ts-common';
import { ModuleFE_PathwayState } from '../../../../../../../_entity/pathway-state/index.js';
import { checkIfPathwayElementChanged } from '../../../../../utils.js';
export class Section_PathwayStates extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        let pathwayStates = ModuleFE_PathwayState.cache.filter(state => state.pathwayIds.includes(this.props.pathwayId));
        pathwayStates = sortArray(pathwayStates, state => state.name.toLowerCase());
        state.relevantStates = pathwayStates;
        return state;
    }
    __onPathwayStateUpdated(...params) {
        if (!this.props.pathwayId)
            return;
        checkIfPathwayElementChanged(this.state.relevantStates, params, (item) => item.pathwayIds?.includes(this.props.pathwayId), () => this.reDeriveState(), () => this.reDeriveState());
    }
    render() {
        return _jsx(TS_CollapsableContainerV2, { headerRenderer: _jsxs(_Fragment, { children: [this.state.relevantStates.length, " States"] }), containerRenderer: _jsx(_Fragment, { children: this.state.relevantStates.map(state => _jsx("div", { className: 'clickable', onClick: () => {
                        this.props.functions.selectPathwayState(state._id);
                    }, children: state.name }, state._id)) }), animated: true });
    }
}
//# sourceMappingURL=Section_PathwayStates.js.map